import { add, listen, qs, qsa, remove, toggle } from '@fluorescent/dom';
import { get, set } from '@fluorescent/storage';
import { slideDown, slideUp, slideStop, isVisible } from 'slide-anim';

import { updateFilters } from '@/lib/filters/events';

const classes = {
  active: 'active',
  closed: 'closed',
};

const ls = {
  getClosed: () => get('closed_sidebar_groups') || [],
  setClosed: val => set('closed_sidebar_groups', JSON.stringify(val)),
};

const sel = {
  heading: '[data-heading]',
  tag: '[data-tag]',
  sort: '[data-sort]',
  form: '[data-filter-form]',
  getGroup: group => `[data-group="${group}"]`,
};

export default node => {
  if (!node) return Function();

  const sortOptions = qsa(sel.sort, node);
  const groupHeadings = qsa(sel.heading, node);

  listen(node, 'change', handleInputChange);
  listen(sortOptions, 'click', handleSortClicked);
  listen(groupHeadings, 'click', handleGroupHeadingClicked);

  function handleGroupHeadingClicked(event) {
    const heading = event.target;
    const { nextElementSibling: content } = event.target;
    slideStop(content);

    const current = ls.getClosed();
    if (isVisible(content)) {
      add(event.target, classes.closed);
      slideUp(content);
      ls.setClosed([...current, heading]);
    } else {
      remove(event.target, classes.closed);
      slideDown(content);
      ls.setClosed(current.filter(item => item !== heading));
    }
  }

  // Hide groups that were previously closed by the user
  const hiddenGroups = ls.getClosed();
  hiddenGroups.forEach(group => {
    const g = qs(sel.getGroup(group), node);
    if (g) {
      add(qs(sel.heading, g), classes.closed);
      slideUp(g.querySelector('ul'), { duration: 1 });
    }
  });

  function handleInputChange(event) {
    const form = event.target.closest(sel.form);
    updateFilters(form);
  }

  function handleSortClicked(event) {
    const form = event.target.closest(sel.form);
    updateFilters(form);
  }
  return () => {
    click();

    tagSubscription();
    sortSubscription();
  };
};
